import { Component, OnInit } from '@angular/core';
import { MainContainerService } from '../main-container/main-container.service';
import { PopupOcorrenciaService } from './popup-ocorrencia.service';
import { ApiConService } from '../shared/api-con.service';
import { IdOrigemMensagem, SituacaoOcorrenciaEspecial, Util } from '../shared/util.service';
import { PopupConfigService } from '../popup-config/popup-config.service';
import { TipoOcorrenciaEspecial } from '../shared/util.service';
import { JsonReturn, ObjectParam } from '../interface/generic-interface';
import { NotificationService } from '../shared/notification.service';
import { AvaliacaoService } from '../modal-avaliacao/avaliacao.service';
import { ConfiguracaoInfoCliente } from '../info-list-ocurrence/info-list-ocurrence.component';


declare var jquery: any;
declare var $: any;

@Component({
  standalone: false,
  selector: 'popup-ocorrencia',
  templateUrl: './popup-ocorrencia.component.html',
  styleUrls: ['./popup-ocorrencia.component.css']
})
export class PopupOcorrenciaComponent implements OnInit {

  public opcaoSelecionado = '';
  public msgValidacao = '';
  loadingEnvioMsg = false;
  public listStatusFinalizacao: any[] = [];
  tipoOcorrenciaEspecial = TipoOcorrenciaEspecial;
  enumTipoSituacao = SituacaoOcorrenciaEspecial
  enumConfiguracaoInfoCliente = ConfiguracaoInfoCliente;
  arquivos = [];
  loading = false;
  intervaloConsultaMsg: any;

  //campos enviado dados arquivos 
  msgArquivo?: string = null
  tipoArquivo?: string = null
  nomeArquivo?: string = null
  conteudoArquivo?: string = null
  tamanhoArquivo?: number = null
  exibeModalAvaliacao: boolean = false;

  constructor(
    public mainContainerService: MainContainerService,
    public popupOcorrenciaService: PopupOcorrenciaService,
    private conService: ApiConService,
    public util: Util,
    public popupConfigService: PopupConfigService,
    private notificationService: NotificationService,
    public avaliacaoService: AvaliacaoService
  ) {

  }

  async ngOnInit() 
  {
    await this.listaStatusFinalizacao();
  }
  
  async ngAfterViewInit() {      
  }

  scroolToBottom() {
    let chatArea = document.getElementById("chat-conteudo");
    chatArea.scrollTop = chatArea.scrollHeight;
  }

  async fecharVisualizacaoOcorrencia() {
    if (Number(this.mainContainerService.ocorrenciaSelecionado[0].IdStatus) === 1) {
      this.mainContainerService.ocorrenciaSelecionado[0].IdStatus = 2;
      this.mainContainerService.ocorrenciaSelecionado[0].Status = 'Em Análise';
      this.mainContainerService.ocorrenciaSelecionado[0].msgNaoVisualizado = 0;
      for (let i = 0; i < this.mainContainerService.ocorrenciaSelecionado[0].ocorrenciaMsg.length; i++) {
        this.mainContainerService.ocorrenciaSelecionado[0].ocorrenciaMsg[i].VisualizadoDistribuidora = 'S';
      }
      await this.popupOcorrenciaService.putVisualizacaoOcorrencia();
      await this.mainContainerService.apagaOcorrenciasPorStatus();
      await this.mainContainerService.separaOcorrenciasPorStatus(true);
      this.mainContainerService.atualizacaoOcorrencia = true;
    }
    $('#msg').html(''); 
    
  }

  async finalizacaoOcorrencia(e) {
    this.opcaoSelecionado === '' ? this.msgValidacao = 'Favor selecionar um Status' : this.msgValidacao = '' ;
    if (this.msgValidacao === '') {
      try {
        
        this.mainContainerService.ocorrenciaSelecionado[0].IdStatus = 3;
        this.mainContainerService.ocorrenciaSelecionado[0].Status = 'Finalizado';
        await this.mainContainerService.apagaOcorrenciasPorStatus();
        $('#popup-ocorrencia').modal('hide');
        this.CancelarFinalizacao(e);
        let id = this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia;
        const IdOcorrencia = this.mainContainerService.ocorrenciaSelecionado[0].IdOcorrencia
        let objParam: ObjectParam =  {
          ocorrencias: {
              IdStatus: 3,
              IdStatusFinalizacao: Number(this.opcaoSelecionado),
              IdOcorrencia: IdOcorrencia,
              Usuario: this.popupOcorrenciaService.usuarioLogado
          }
        }

        const responseOcorrencia = await this.conService.put('DCocorrencias', String(id), objParam);
        this.mainContainerService.atualizacaoOcorrencia = true;
        this.opcaoSelecionado = '';
        await this.mainContainerService.separaOcorrenciasPorStatus(true);
        await this.verificaExisteAvaliacao();
      }catch (Error) {
        console.log("CATCH________finalizacaoOcorrencia");
        console.log(Error);
      }
    }
  }

  async ConfirmarFinalizacao(e) 
  {
    $(e.currentTarget).addClass('disabled');
    $('#statusFinalizacao option:first').prop('selected', true);
    $('.confirmacao').addClass('open');
  };

  CancelarFinalizacao(e) 
  {
    $('#statusFinalizacao').val('0');
    $('#ocorrencia-finalizar').removeClass('disabled');
    $('.confirmacao').removeClass('open');
  };

  async enviarMsg(arquivo = false) 
  {
    let msg = '';
    let nomeAtendente: string = '';
    if(arquivo){
      let objMensagem = {
        msg : this.msgArquivo,  
        tipoArquivo: this.tipoArquivo,
        nomeArquivo: this.nomeArquivo,
        tamanhoArquivo : this.tamanhoArquivo
      }
      msg = JSON.stringify(objMensagem);
    }else{
      msg =  (document.getElementById('msg') as HTMLInputElement).value;
    }

    
    if (msg != '') {      
      let id = this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia;
      let idOcorrencia = this.mainContainerService.ocorrenciaSelecionado[0].IdOcorrencia;
      let dataAtual = new Date();
      nomeAtendente = this.tratarNomeAtendente();
      
      let jsonOcorrenciaMsg: any = 
      {
        'IdOrigem': IdOrigemMensagem.Distribuidora,
        'CodigoOcorrencia': String(id),
        'Mensagem': msg,
        'Data' : this.util.converterDataSemFuso(dataAtual),
        'Transmitido': 0,
        'IdOcorrencia': idOcorrencia,
        'Storage' : arquivo? 1: 0,
        'arquivo': this.conteudoArquivo? this.util.compress(this.conteudoArquivo)  : null,
        'NomeAtendente' : nomeAtendente
      };

      let objParam: ObjectParam = {
        ocorrenciaMensagem: {
          IdOrigem: IdOrigemMensagem.Distribuidora,
          CodigoOcorrencia: String(id),
          Mensagem: msg,
          Data :  this.util.converterDataSemFuso(dataAtual),
          Transmitido: false,
          IdOcorrencia: idOcorrencia,
          Storage : arquivo? true: false,
          arquivo: this.conteudoArquivo? this.util.compress(this.conteudoArquivo)  : null,
          NomeAtendente : nomeAtendente
        }
      }

      this.loadingEnvioMsg = true;
      const responseOcorrencia: JsonReturn = await this.conService.post('DCocorrenciaMensagem', objParam);

      if(arquivo){
        jsonOcorrenciaMsg.Mensagem = JSON.parse(jsonOcorrenciaMsg.Mensagem)
        let dataExpiracao = new Date(jsonOcorrenciaMsg.Data.replace('Z', ''))
        dataExpiracao.setHours(dataExpiracao.getHours() + 48);
        jsonOcorrenciaMsg.expirou = this.util.expirouTempo(48 , jsonOcorrenciaMsg.Data);       
        jsonOcorrenciaMsg.dataExpiracao = dataExpiracao;
        jsonOcorrenciaMsg.Mensagem.nomeArquivo = this.util.trataNameArquivo(jsonOcorrenciaMsg.Mensagem.nomeArquivo, 30)
        jsonOcorrenciaMsg.IdMensagem = responseOcorrencia.response[0].IdMensagem
      }
      
      let data = this.util.converterDataSemFuso(dataAtual).replace(" ", "T") + "Z";
      jsonOcorrenciaMsg.Data = data;

      if(responseOcorrencia.sucesso){
        this.mainContainerService.ocorrenciaSelecionado[0].ocorrenciaMsg.push(jsonOcorrenciaMsg);
        setTimeout(() => {
          this.scroolToBottom();
        }, 1);
      }      
  
      this.loadingEnvioMsg = false;
    }
    (document.getElementById('msg') as HTMLInputElement).value = '';
  }

  tratarNomeAtendente(): string {
    let nomeAtendente = this.popupOcorrenciaService.usuarioLogado
    nomeAtendente = nomeAtendente.split('@')[0];
    nomeAtendente = nomeAtendente.replace(/\./g, ' ');
    return nomeAtendente.toUpperCase();
  }

  retornaStatus() {
    const status = this.mainContainerService.ocorrenciaSelecionado[0].IdStatus;
    let retorno = '';
    switch (status) {
      case 1: retorno = 'status-novo'; break;
      case 2: retorno = 'status-analise'; break;
      case 3: retorno = 'status-finalizado'; break;
    }
    return retorno;
  }

  async listaStatusFinalizacao() 
  {
    this.popupConfigService.vetListaStatusFinalizacao = await this.popupConfigService.getListaStatusFinalizacao();
    this.listStatusFinalizacao = [];

    for (let i = 0; i < this.popupConfigService.vetListaStatusFinalizacao.length; i++) 
    {
      if (String(this.popupConfigService.vetListaStatusFinalizacao[i].Ativo) === 'S') 
      {
        this.listStatusFinalizacao.push(this.popupConfigService.vetListaStatusFinalizacao[i]);
      }
    }

    this.popupConfigService.vetListaStatusFinalizacao = [];
    this.popupConfigService.vetListaStatusFinalizacao = this.listStatusFinalizacao;

  }

  onChangeObj(opcaoSelecionado: any) {
    this.opcaoSelecionado = opcaoSelecionado;
    this.opcaoSelecionado === '' ? this.msgValidacao = 'Favor selecionar um Status!' : this.msgValidacao = '';
    this.popupOcorrenciaService.statusFinalizacaoSelecionado = opcaoSelecionado;
  }

  nomefuncao(dado: any) : string
  {
    return '';

  }
  isBase64(str: any) {
    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    var isbase64 = base64regex.test(str) && str.length > 200 && !str.includes(" ") ;    
    return isbase64;    
  }

  async atualizarMensagens(responseMsg?: JsonReturn){
    let msgInicialData = [];
    let dataPrimeiraMsg = '';
    this.mainContainerService.atualizacaoOcorrencia = false;
    this.mainContainerService.ocorrenciaSelecionado = [];
    this.mainContainerService.listaOcorrenciaLogs = [];
    this.mainContainerService.ocorrenciaSelecionado.push(this.popupConfigService.objOcorrencia);
    this.popupOcorrenciaService.loadingMsg = true;
    if(responseMsg == null){
      responseMsg = await this.conService.patch('DCocorrenciaMensagem/' +this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia);
    }
    this.mainContainerService.listaOcorrenciaLogs = await this.popupConfigService.getListaOcorrenciaLog( this.mainContainerService.ocorrenciaSelecionado[0].IdOcorrencia)
    this.popupOcorrenciaService.loadingMsg = false;
    this.mainContainerService.listaOcorrenciasMsg = responseMsg.response;

    //Trata Custo Extra
    if(this.mainContainerService?.ocorrenciaSelecionado[0]?.TipoEspecial == this.tipoOcorrenciaEspecial.CUSTO_EXTRA){
      dataPrimeiraMsg = this.mainContainerService.listaOcorrenciasMsg[0].Data;
      msgInicialData = this.mainContainerService.listaOcorrenciasMsg.filter((element) => element.Data == dataPrimeiraMsg);
      this.mainContainerService.ocorrenciaSelecionado[0].imagensCustoExtra = []
      msgInicialData.forEach((dadosMsg) =>{
        let isBase64 = this.isBase64(dadosMsg?.Mensagem)
        if(isBase64){
          this.mainContainerService.ocorrenciaSelecionado[0].imagensCustoExtra.push(dadosMsg?.Mensagem) 
        }else{
          this.mainContainerService.ocorrenciaSelecionado[0].msgCustoExtra = dadosMsg?.Mensagem;
        }
      })
    }


    this.mainContainerService.listaOcorrenciasMsg = this.mainContainerService.listaOcorrenciasMsg.map((element) => {
        element.Mensagem = element.Mensagem.replaceAll('\\n', '<br>' )
         return element
    }) 
    for (let x = 0; x < this.mainContainerService.listaOcorrencias.length; x++)
    {
      if (String(this.mainContainerService.listaOcorrencias[x].CodigoOcorrencia) === String(this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia)) 
      {        
        this.mainContainerService.ocorrenciaSelecionado[0].ocorrenciaMsg = responseMsg.response.splice(msgInicialData.length);
      }
      if (this.mainContainerService.listaOcorrencias[x].InfoRota) 
      {
        this.mainContainerService.listaOcorrencias[x].InfoRota = JSON.parse(this.mainContainerService.listaOcorrencias[x].InfoRota);
      }
    }
    const response = await this.popupConfigService.getListaStatusFinalizacao();
    this.scroolToBottom();
  }
 
  async atualizaSituacao(situacao: string, tipoOcorrencia: string){
    let textoMsg = tipoOcorrencia == this.tipoOcorrenciaEspecial.SANEAMENTO_CLIENTE ? 
        'Sua solicitação foi recebida pela retaguarda e foi processada.' :
        `Sua solicitação foi ${situacao == this.enumTipoSituacao.Encerrado? 'aceita' : 'recusada'} pela retaguarda.` 
    this.mainContainerService.ocorrenciaSelecionado[0].Situacao  = situacao;
    let json = JSON.parse(this.mainContainerService.ocorrenciaSelecionado[0].Json);
    delete json.usuario;
    delete json.dataRecusaAceite

    json.dataRecusaAceite = new Date().toLocaleString();
    json = {...json, usuario : this.consultaUsuario()}  
    let objParam: ObjectParam = {
      ocorrenciaEspecial: {
        Json: JSON.stringify(json),
        OcorrenciaEspecialID: this.mainContainerService.ocorrenciaSelecionado[0].OcorrenciaEspecialID,
        Situacao:  this.mainContainerService.ocorrenciaSelecionado[0].Situacao,
        OcorrenciaID: this.mainContainerService.ocorrenciaSelecionado[0].IdOcorrencia,
        TipoEspecial: this.mainContainerService.ocorrenciaSelecionado[0].TipoEspecial
      }
    }
    await this.popupConfigService.atualizaSituacaoOcEspecial(objParam.ocorrenciaEspecial.OcorrenciaEspecialID, objParam);
    (document.getElementById('msg') as HTMLInputElement).value = textoMsg;
    await this.enviarMsg();

  }

  consultaUsuario(): string{
    let url = new URL(window.location.href);
    let nomeUsuario: any = url.searchParams.get('opc3');
    nomeUsuario = atob(nomeUsuario);
    return nomeUsuario;
  }

  anexarArquivos(){
    document.getElementById('inputFilePDFXML').click()
  }

  selecionaArquivos(event: any) {
    const files: FileList = event.target.files;
    if (files.length > 0) {   

      for (let i = 0; i < files.length; i++) {
        const file: any = files[i];

        const reader = new FileReader();
        reader.onload = (e: any) => {
            const conteudoArquivo = e.target.result.split(',')[1];
            file.nome = this.util.trataNameArquivo(file.name, 27);                  
            file.conteudoArquivo = conteudoArquivo;
            if(file.type == "text/xml"){
              file.XML = true;
              this.addArquivo(file)
            }else if(file.type == "application/pdf"){
              file.PDF = true;
              this.addArquivo(file)
            }       
        };
        reader.readAsDataURL(file);
      }

      if(!this.loading){
        document.getElementById('btnMostraArquivos').click();
      }
      this.loading = true;     
    }
  }

  fechaAnexaArquivo(){
    this.loading = false;
  }

  addArquivo(file){
    let contemArquivo = this.arquivos.some((arquivo) => arquivo.name == file.name);
    if(!contemArquivo){
      this.arquivos.push(file)
    }
  }

  removeArquivo(fileName: string) {
    this.arquivos = this.arquivos.filter((arquivo) => arquivo.name !== fileName);
  }


  async enviarArquivos(){

    this.btnFechaModalArquivo();

    for (let i = 0; i < this.arquivos.length; i++) {
      let dadosArquivo = this.arquivos[i];
      this.conteudoArquivo = dadosArquivo.conteudoArquivo;
      this.nomeArquivo = dadosArquivo.name;
      this.tipoArquivo = dadosArquivo?.XML ? 'xml' : 'pdf';
      this.msgArquivo = this.msgArquivo? this.msgArquivo : ''
      this.tamanhoArquivo = parseFloat((dadosArquivo.size / 1024).toFixed(2));
      

      await this.enviarMsg(true);
    }

    this.resetDadosArquivos();
    this.fechaAnexaArquivo();
    this.arquivos = [];
  }

  resetDadosArquivos(){
    this.conteudoArquivo = null
    this.nomeArquivo = null
    this.tipoArquivo = null
    this.msgArquivo =  null
    this.tamanhoArquivo = null
  }

  btnFechaModalArquivo(){
    document.getElementById('btnCloseModalArquivo').click()
  }


  async consultaArquivo(dados, download = false){
    this.loading = true; 
    let response: JsonReturn = await this.popupOcorrenciaService.consultaArquivo(dados.CodigoOcorrencia, dados.IdMensagem, dados.Mensagem.tipoArquivo);

    let base64 = this.util.decompress(response.response);

    if(!download){
  
      var novaAba = window.open("", "_blank");
      novaAba.document.write('<html><body><object width="100%" height="100%" type="application/pdf" data="data:application/pdf;base64,' + base64 + '"><embed type="application/pdf" src="data:application/pdf;base64,' + base64 + '"></embed></object></body></html>');
      novaAba.document.close();
      
    }else{
      this.downloadArquivo(base64, dados.Mensagem.nomeArquivo, dados.Mensagem.tipoArquivo)
    }
    
    this.loading = false;
  }

  downloadArquivo(base64: string, nomeArquivo: string, tipoArquivo: string ) {
    const bytes = atob(base64);
    const bytesNumeros = new Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
        bytesNumeros[i] = bytes.charCodeAt(i);
    }
    const byteArray = new Uint8Array(bytesNumeros);
    const blob = new Blob([byteArray], { type: tipoArquivo == 'xml'? 'application/xml' : 'application/pdf' }); 

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = nomeArquivo;
    link.click();
  }

  
  copiarAcomponhamento(chaveAcesso){
     navigator.clipboard.writeText(`http://rastreiotgt.net/?chaveAcesso=${chaveAcesso}`).then(() => {
      this.notificationService.showInformativo('Texto copiado para a área de transferência')
    }).catch((error) => {
      console.error('Erro ao copiar para a área de transferência: ', error);
    });
  }

  async verificaExisteAvaliacao() {
    try {
      const response = await this.avaliacaoService.getAvaliacaoPesquisa('ENCERRAR');
      this.avaliacaoService.exibirModalAvaliacao = Array.isArray(response) && response.length > 0;

    } catch (error) {
      console.error('Erro ao verificar avaliação:', error);
    }
  }

  iniciarConsultaMsg(){
    this.intervaloConsultaMsg = setInterval(async () => {
      const responseMsg: JsonReturn = await this.conService.patch('DCocorrenciaMensagem/' + this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia);
      if(responseMsg.response.length > this.mainContainerService.listaOcorrenciasMsg.length){
        this.atualizarMensagens(responseMsg)
      }
    }, 10000);
   }

  pararConsultaMsg() {
    if (this.intervaloConsultaMsg) {
      clearInterval(this.intervaloConsultaMsg);
      this.intervaloConsultaMsg = null;
    }
  }
}
